



















































































import { Component, Vue } from 'vue-property-decorator';
import { 認証型 } from '@/type/authentication/authentication';
import DeliveryDataDetail from '@/views/stock/deliverydata/DeliveryDataDetail.vue';
import {ja} from 'vuejs-datepicker/dist/locale';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';

import { 納品データ受信型, 納品データ受信依頼型, 納品データ受信依頼バリデータ一覧, 依頼ステータス区分型 } from '@/type/stock/deliverydata/deliverydata';
import { ValidationResult } from '@/type/validation/result';

import moment from 'moment';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';

@Component({
  components: {
    Datepicker,
    DeliveryDataDetail,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
  },
  filters: {
    dateFormat(value: Date): string {
      if (!value) {
        return '';
      }
      moment.locale('ja');
      return moment(value).format('YYYY/MM/DD');
    },
    timeFormat(value: Date): string {
      if (!value) {
        return '';
      }
      moment.locale('ja');
      return moment(value).format('HH:mm:ss');
    },
    requestStatusFormat(value: 依頼ステータス区分型): string {
      if (!value) {
        return '';
      }
      if (value === 依頼ステータス区分型.依頼中_手動更新) {
        return '依頼中(手動更新)';
      }
      if (value === 依頼ステータス区分型.依頼中_自動更新) {
        return '依頼中(自動更新)';
      }
      return value;
    },
  },
})
export default class ListDeliveryData extends Vue {
  private language: object = ja;
  private modal: boolean = false;
  private 納品データ受信一覧: 納品データ受信型[] = [];
  private 納品データ受信依頼: 納品データ受信依頼型 = {
    依頼日From: moment().startOf('month').toDate(),
    依頼日To: null,
    依頼ステータス区分: null,
  };
  private 選択納品データ受信: 納品データ受信型 | null = null;
  private アラートメッセージ: string | string[] | null = null;

  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(納品データ受信依頼バリデータ一覧);

  private async 検索する(): Promise<void> {
    this.納品データ受信一覧 = [];
    this.選択納品データ受信 = null;
    await api.納品依頼を検索する(this.納品データ受信依頼)
      .then((response: any) => {
        this.納品データ受信一覧 = response.納品依頼一覧;
        if (this.納品データ受信一覧.length === 0) {
          this.アラートメッセージ = '該当のデータはありません';
          this.$modal.show('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
        this.$modal.show('アラート');
      });
  }

  private 表示件数を取得(): number {
    return this.納品データ受信一覧.length;
  }

  private closeDialog() {
    this.modal = false;
  }

  private beforeUpdate(): void {
    this.検索条件バリデーション結果.validate(this.納品データ受信依頼);
  }

  private 入力エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  private async 検索するハンドラ(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.検索する);
  }

  private async 受信を指示するハンドラ(): Promise<void> {
    await progress(this.受信を指示する);
  }

  private async 受信を指示する(): Promise<void> {
    await api.納品データ受信を指示する()
      .catch((error: any) => {
        this.納品データ受信確認ダイアログを閉じる();
        this.アラートメッセージ = error.data.message;
        this.$modal.show('アラート');
        return Promise.reject(error);
      });
    await new Promise((resolve) => setTimeout(resolve, 10000));
    this.納品データ受信確認ダイアログを閉じる();
    this.検索する();
  }

  private 納品データ受信確認ダイアログを開く(): void {
    this.$modal.show('納品データ受信確認ダイアログ');
  }

  private 納品データ受信確認ダイアログを閉じる(): void {
    this.$modal.hide('納品データ受信確認ダイアログ');
  }

  private 照会ダイアログを開く(): void {
    if (this.選択納品データ受信 !== null) {
      this.modal = true;
    }
  }

  private リストから選択する(納品データ受信: 納品データ受信型): void {
    this.選択納品データ受信 = 納品データ受信;
  }

  private 照会不可である(): boolean {
    if (this.選択納品データ受信 === null) {
      return true;
    }
    if (this.選択納品データ受信.納品番号 === null) {
      return true;
    }
    return false;
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }
}
